import { AsyncSubject, Observable } from 'rxjs';
import { DateTime } from 'luxon';

import { Notifications } from '../data/models/notifications.model';
import { PackageSettings } from '../data/models/package-setting.model';
import {
  ApplicationGlobalSettingRequest,
  ApplicationGlobalSettingResponse,
  CreateApplicationGlobalSettingRequest,
  UpdateApplicationGlobalSettingRequest,
} from '../data/models/application-setting.model';

import httpService from './httpService';

class SettingsService {
  private readonly apiBase;
  private readonly apiLookupBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_SETTINGS_API_URL?.trim();
    this.apiLookupBase =
      __environment__.REACT_APP_GLOBAL_SETTINGS_API_URL?.trim();
  }

  public getNotificationSettings(): Observable<Notifications> {
    // const url = `${this.apiBase}/notifications`;
    // return httpService.getJSON(url);
    // TODO: returning mock data for now

    const subject = new AsyncSubject<Notifications>();
    subject.next({
      oneDayAheadTripNotification: 0,
      dayOfTripNotification: 0,
      willCallDropoffNotification: 0,
      followUpWillCallMessage: 0,
      tripLegPackagingTime: DateTime.now().toISO(),
      tripLegPackagingDaysPrior: 0,
      tripLegPackageAcceptanceTimeout: 0,
      leadTimeForSmsToDriver: 0,
    });
    subject.complete();
    return subject;
  }

  public updateNotificationSettings(payload: Notifications): Observable<any> {
    // const url = `${this.apiBase}/notifications`;
    // return httpService.patchJSON(url, payload);
    // TODO: returning payload for now

    const subject = new AsyncSubject<Notifications>();
    subject.next(payload);
    subject.complete();
    return subject;
  }

  public getPackageSettings(): Observable<PackageSettings> {
    // const url = `${this.apiBase}/package`;
    // return httpService.getJSON(url);

    const subject = new AsyncSubject<PackageSettings>();
    subject.next({
      deliveryTimingToProviderStartTime: DateTime.now().toISO(),
      deliveryTimingToProviderEndTime: DateTime.now().toISO(),
      deliveryTimingToProviderDaysPrior: 0,
    });
    subject.complete();
    return subject;
  }

  public updatePackageSettings(payload: PackageSettings): Observable<any> {
    // const url = `${this.apiBase}/package`;
    // return httpService.patchJSON(url, payload);

    const subject = new AsyncSubject<PackageSettings>();
    subject.next(payload);
    subject.complete();
    return subject;
  }

  public getApplicationGlobalSetting(
    payload: ApplicationGlobalSettingRequest | number | undefined,
  ): Observable<ApplicationGlobalSettingResponse[]> {
    let url = `${this.apiLookupBase}`;
    if (typeof payload === 'number') {
      url = `${this.apiLookupBase}/${payload}`;
    } else if (
      payload !== undefined &&
      typeof payload === 'object' &&
      'applicationTitleBC' in payload &&
      'applicationSettingBC' in payload
    ) {
      url = `${this.apiLookupBase}?applicationTitleBC=${(payload as ApplicationGlobalSettingRequest).applicationTitleBC}&applicationSettingBC=${(payload as ApplicationGlobalSettingRequest).applicationSettingBC}`;
    }
    return httpService.getJSON(url);
  }

  public getApplicationGlobalSettings(
    payload: ApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse[]> {
    let url = `${this.apiLookupBase}`;
    const params = new URLSearchParams();
    if (
      payload.applicationTitleBC &&
      payload.applicationTitleBC.trim() !== ''
    ) {
      params.set('applicationTitleBC', payload.applicationTitleBC);
    }
    if (
      payload.applicationSettingBC &&
      payload.applicationSettingBC.trim() !== ''
    ) {
      params.set('applicationSettingBC', payload.applicationSettingBC);
    }
    if (payload.search && payload.search.trim() !== '') {
      params.set('search', payload.search);
    }
    if (
      payload.sortModel &&
      payload.sortModel.column &&
      payload.sortModel.direction
    ) {
      params.set('sort', payload.sortModel.column);
      params.set('sortOrder', payload.sortModel.direction);
    }
    url += `?${params.toString()}`;
    return httpService.getJSON(url);
  }

  public deleteApplicationGlobalSetting(
    applicationGlobalSettingID: number,
  ): Observable<any> {
    return httpService.deleteJSON(
      `${this.apiLookupBase}/${applicationGlobalSettingID}`,
    );
  }

  public createApplicationGlobalSetting(
    payload: CreateApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse> {
    return httpService.postJSON(`${this.apiLookupBase}`, payload);
  }

  public updateApplicationGlobalSetting(
    payload: UpdateApplicationGlobalSettingRequest,
  ): Observable<ApplicationGlobalSettingResponse> {
    return httpService.patchJSON(
      `${this.apiLookupBase}/${payload.applicationSettingID}`,
      { applicationSettingValue: payload.applicationSettingValue },
    );
  }
}

const settingsService = new SettingsService();

export default settingsService;
